export const SET_PAGE_NOT_FOUND = 'SET_PAGE_NOT_FOUND'
